<app-button
  variant="ghost"
  class="ord-modal-button-close"
  svgIcon="close"
  ariaLabel="Close"
  [disabled]="loading()"
  (btnClick)="closeDialog()"
/>
<h2 mat-dialog-title class="ord-modal-title">
  <mat-icon
    svgIcon="warn"
    class="ord-icon ord-icon-lg ord-text-yellow"
  ></mat-icon>
  <span>Park Transaction</span>
</h2>
<mat-dialog-content class="ord-modal-content">
  <div class="space-y-3 w-full">
    <div class="block text-sm font-medium mb-1">
      Parked Transactions {{ meta().total > 0 ? meta().total : "" }}
    </div>
    @if (loading()) {
    <div class="flex justify-center">
      <mat-progress-spinner mode="indeterminate" />
    </div>
    } @else if (parkedTransactions().length) {
    <div class="space-y-3">
      <ul class="space-y-2 mb-4">
        @for (transaction of parkedTransactions(); track transaction.id) {
        <li class="pr-1">
          <button
            class="w-full h-full text-left py-3 px-4 rounded bg-white dark:bg-slate-800 border-2 shadow-sm duration-150 ease-in-out"
            [class.border-indigo-500]=" selectedUuid() === transaction.uuid "
            (click)="selectedUuid.set(transaction.uuid)"
          >
            <div class="flex items-center">
              <div>
                <div
                  class="w-4 h-4 border-4 bg-white rounded-full mr-5"
                  [class.border-indigo-500]="
                    selectedUuid() === transaction.uuid
                  "
                ></div>
              </div>
              <div class="w-full">
                <div
                  class="mb-0.5 font-medium text-slate-800 dark:text-slate-100 grid grid-cols-3 gap-3 items-center"
                >
                  <div>
                    <app-badge
                      text="#{{ transaction.uuid.split('-').slice(-1)[0] }}"
                    ></app-badge>
                  </div>
                  <div class="col-span-2">
                    Parked on
                    {{ transaction.timestamp | date : "MMM dd, yyyy HH:mm" }}
                  </div>
                </div>
              </div>
            </div>
          </button>
        </li>
        }
      </ul>
    </div>
    @if(meta().total > PAGE_SIZE) {
    <div class="pagination">
      <app-pagination
        [changeRouteQuery]="false"
        [currentPage]="meta().page ?? 1"
        [numberOfItems]="meta().total"
        (pageChange)="onPageChange($event)"
      />
    </div>
    } } @else {
    <div class="ord-body-1 text-gray-500 w-full text-center py-2">
      No parked transactions found
    </div>
    }
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="ord-modal-actions">
  @if(errorMessages() && errorMessages().length > 0) {
  <app-error-list class="ord-modal-errors" [errorMessages]="errorMessages()" />
  }
  <app-button
    variant="secondary"
    [disabled]="loading()"
    (btnClick)="closeDialog()"
  >
    <ng-template appButtonText>Cancel</ng-template>
  </app-button>
  <app-button
    variant="primary"
    [disabled]="loading() || !selectedUuid()"
    [loading]="loading()"
    (btnClick)="retrieveTransaction()"
  >
    <ng-template appButtonText>Retrieve</ng-template>
  </app-button>
</mat-dialog-actions>
